export default __webpack_public_path__ + "static/dressing.range-ca8f01dc35656fe4c59ceed04dd8e1fb.jpg";